if (!window.vkSizeGuideModalInitialized) {
  window.vkSizeGuideModalInitialized = true;

  const closeSizeGuide = (dialog) => {
    if (dialog?.open) dialog.close();
  };

  const bindSizeGuideModal = (dialog) => {
    if (dialog.dataset.vkSizeGuideModalBound === 'true') return;

    dialog.dataset.vkSizeGuideModalBound = 'true';

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeSizeGuide(dialog);
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeSizeGuide(dialog);
    });

    dialog.addEventListener('close', () => {
      if (
        !dialog.vkBodyWasLocked &&
        !document.querySelector('dialog[open], modal-dialog[open], product-modal[open]')
      ) {
        document.body.classList.remove('overflow-hidden');
      }

      const opener = dialog.vkOpener;
      opener?.setAttribute('aria-expanded', 'false');

      if (opener?.isConnected) {
        window.requestAnimationFrame(() => opener.focus({ preventScroll: true }));
      }

      dialog.vkOpener = null;
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const opener = target?.closest('[data-vk-size-guide-open]');

    if (opener) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

      event.preventDefault();
      bindSizeGuideModal(dialog);
      dialog.vkOpener = opener;
      dialog.vkBodyWasLocked = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      opener.setAttribute('aria-expanded', 'true');
      dialog.showModal();
      dialog.querySelector('[data-vk-size-guide-close]')?.focus({ preventScroll: true });
      return;
    }

    const closeButton = target?.closest('[data-vk-size-guide-close]');
    const dialog = closeButton?.closest('dialog.vk-size-guide-modal');
    closeSizeGuide(dialog);
  });
}
